/**
 * progressSignal — module-level pub-sub for the global progress bar.
 *
 * Multiple concurrent callers are supported via a reference count.
 * The bar stays visible as long as any caller has an active load.
 *
 * Usage:
 *   progressSignal.start();   // begin a load
 *   progressSignal.done();    // end a load
 *   progressSignal.subscribe(fn);  // fn(true | false)
 */
let _activeCount = 0;
const _listeners = new Set();

const notify = (loading) => _listeners.forEach((fn) => fn(loading));

const progressSignal = {
  start() {
    _activeCount += 1;
    if (_activeCount === 1) notify(true);
  },

  done() {
    if (_activeCount === 0) return; // nothing in flight
    _activeCount -= 1;
    if (_activeCount === 0) notify(false);
  },

  /** Force-reset (e.g. on unrecoverable error). */
  reset() {
    _activeCount = 0;
    notify(false);
  },

  subscribe(fn) {
    _listeners.add(fn);
    return () => _listeners.delete(fn);
  },
};

export default progressSignal;
